(function () {
  var EARTH_RADIUS_KM = 6371;
  var NEARBY_RADIUS_KM = 40;
  var NEAREST_FALLBACK_COUNT = 20;
  var MAP_FOCUS_COUNT = 3;
  var LIST_PREVIEW_COUNT = 3;
  var LOAD_MORE_COUNT = 10;
  var OTHER_COUNT = 5;
  var DAY_INDEX = {
    sunday: 0, sun: 0, 'الأحد': 0, الاحد: 0, أحد: 0,
    monday: 1, mon: 1, الإثنين: 1, الاثنين: 1, إثنين: 1, اثنين: 1,
    tuesday: 2, tue: 2, الثلاثاء: 2,
    wednesday: 3, wed: 3, الأربعاء: 3, الاربعاء: 3, أربعاء: 3, اربعاء: 3,
    thursday: 4, thu: 4, الخميس: 4, خميس: 4,
    friday: 5, fri: 5, الجمعة: 5, جمعة: 5,
    saturday: 6, sat: 6, السبت: 6, سبت: 6
  };

  function readJson(id) {
    var node = document.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function t(key, vars) {
    var dict = window.DkhounBranchesI18n || {};
    var value = dict[key] || '';
    if (!vars) return value;
    Object.keys(vars).forEach(function (name) {
      value = value.replace('{{' + name + '}}', vars[name]);
    });
    return value;
  }

  function isAr() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  }

  function normalizeSearchText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[أإآٱ]/g, 'ا')
      .replace(/ى/g, 'ي')
      .replace(/ة/g, 'ه')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function extractLatLng(url) {
    if (!url) return null;
    var encoded = [];
    var re = /!3d(-?\d+(?:\.\d+)?)!4d(-?\d+(?:\.\d+)?)/g;
    var match;
    while ((match = re.exec(url))) encoded.push(match);
    if (encoded.length) {
      var last = encoded[encoded.length - 1];
      return { latitude: parseFloat(last[1]), longitude: parseFloat(last[2]) };
    }
    var qMatch = url.match(/[?&]q=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
    if (qMatch) return { latitude: parseFloat(qMatch[1]), longitude: parseFloat(qMatch[2]) };
    var destMatch = url.match(/[?&]destination=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
    if (destMatch) return { latitude: parseFloat(destMatch[1]), longitude: parseFloat(destMatch[2]) };
    var atMatch = url.match(/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
    if (atMatch) return { latitude: parseFloat(atMatch[1]), longitude: parseFloat(atMatch[2]) };
    return null;
  }

  function distanceKm(from, to) {
    var toRad = function (deg) { return (deg * Math.PI) / 180; };
    var dLat = toRad(to.latitude - from.latitude);
    var dLng = toRad(to.longitude - from.longitude);
    var lat1 = toRad(from.latitude);
    var lat2 = toRad(to.latitude);
    var a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
    return 2 * EARTH_RADIUS_KM * Math.asin(Math.min(1, Math.sqrt(a)));
  }

  function formatDistanceKm(km) {
    var value = km < 10 ? km.toFixed(1) : String(Math.round(km));
    return isAr() ? value.replace('.', ',') : value;
  }

  function parseTimeToMinutes(raw) {
    var value = String(raw || '').trim().toLowerCase();
    var match = value.match(/(\d{1,2})[:.](\d{2})/);
    if (!match) return null;
    var hours = Number(match[1]);
    var minutes = Number(match[2]);
    var isPm = /pm|م/.test(value);
    var isAm = /am|ص/.test(value);
    if (isPm && hours < 12) hours += 12;
    if (isAm && hours === 12) hours = 0;
    return hours * 60 + minutes;
  }

  function weekdayFromLabel(label) {
    var normalized = String(label || '').trim().toLowerCase();
    if (Object.prototype.hasOwnProperty.call(DAY_INDEX, normalized)) return DAY_INDEX[normalized];
    var stripped = normalized.replace(/^ال/, '');
    if (Object.prototype.hasOwnProperty.call(DAY_INDEX, stripped)) return DAY_INDEX[stripped];
    var asNumber = Number(normalized);
    if (asNumber >= 0 && asNumber <= 6) return asNumber;
    return null;
  }

  function isOpenSlot(entry) {
    return entry && entry.closed !== true && entry.closed !== 'true'
      && parseTimeToMinutes(entry.openingTime) !== null
      && parseTimeToMinutes(entry.closingTime) !== null;
  }

  function slotWindow(entry, nowMinutes) {
    var open = parseTimeToMinutes(entry.openingTime);
    var close = parseTimeToMinutes(entry.closingTime);
    if (open === null || close === null) return null;
    var now = nowMinutes;
    var end = close;
    if (end <= open) {
      if (now < open) now += 24 * 60;
      end += 24 * 60;
    }
    return { start: open, end: end, now: now };
  }

  function groupHoursByDay(hours) {
    var groups = {};
    (hours || []).forEach(function (entry) {
      var weekday = weekdayFromLabel(entry.day);
      if (weekday === null) return;
      groups[weekday] = groups[weekday] || [];
      groups[weekday].push(entry);
    });
    var schedule = [];
    for (var weekday = 0; weekday <= 6; weekday += 1) {
      var entries = groups[weekday];
      if (!entries || !entries.length) continue;
      var slots = entries.filter(isOpenSlot).sort(function (a, b) {
        return (parseTimeToMinutes(a.openingTime) || 0) - (parseTimeToMinutes(b.openingTime) || 0);
      });
      schedule.push({ weekday: weekday, slots: slots, isClosed: slots.length === 0 });
    }
    return schedule;
  }

  function sameSchedule(left, right) {
    if (left.isClosed !== right.isClosed) return false;
    if (left.isClosed) return true;
    if (left.slots.length !== right.slots.length) return false;
    return left.slots.every(function (slot, index) {
      var other = right.slots[index];
      return parseTimeToMinutes(slot.openingTime) === parseTimeToMinutes(other.openingTime)
        && parseTimeToMinutes(slot.closingTime) === parseTimeToMinutes(other.closingTime);
    });
  }

  function groupConsecutiveDays(schedule) {
    return schedule.reduce(function (groups, day) {
      var last = groups[groups.length - 1];
      var lastWeekday = last && last.weekdays[last.weekdays.length - 1];
      if (last && lastWeekday !== undefined && day.weekday === lastWeekday + 1 && sameSchedule(last, day)) {
        last.weekdays.push(day.weekday);
        return groups;
      }
      groups.push({ weekdays: [day.weekday], slots: day.slots, isClosed: day.isClosed });
      return groups;
    }, []);
  }

  var DAY_KEYS = ['day_sunday', 'day_monday', 'day_tuesday', 'day_wednesday', 'day_thursday', 'day_friday', 'day_saturday'];

  function formatDayRange(weekdays) {
    var first = t(DAY_KEYS[weekdays[0]]);
    if (weekdays.length === 1) return first;
    var last = t(DAY_KEYS[weekdays[weekdays.length - 1]]);
    if (weekdays.length === 2) return first + ' ' + t('hours_and') + ' ' + last;
    return t('hours_from') + ' ' + first + ' ' + t('hours_to') + ' ' + last;
  }

  function formatHour12(raw) {
    var total = parseTimeToMinutes(raw);
    if (total === null) return String(raw || '').trim() || null;
    var hour24 = Math.floor(total / 60) % 24;
    var minutes = total % 60;
    var hour12 = hour24 % 12 || 12;
    var clock = hour12 + ':' + String(minutes).padStart(2, '0');
    var period = hour24 >= 12 ? t('time_evening') : t('time_morning');
    return clock + ' ' + period;
  }

  function formatHourRange(open, close) {
    var start = formatHour12(open);
    var end = formatHour12(close);
    if (!start || !end) return '';
    return start + ' – ' + end;
  }

  function resolveBranchStatus(hours) {
    var schedule = groupHoursByDay(hours);
    var today = schedule.find(function (day) { return day.weekday === new Date().getDay(); });
    var todaySlots = today && !today.isClosed ? today.slots : [];
    if (!todaySlots.length) return { label: t('closed'), tone: 'closed' };
    var nowMinutes = new Date().getHours() * 60 + new Date().getMinutes();
    var windows = todaySlots.map(function (slot) { return slotWindow(slot, nowMinutes); }).filter(Boolean).sort(function (a, b) { return a.start - b.start; });
    if (!windows.length) return { label: t('closed'), tone: 'closed' };
    var current = windows.find(function (window) { return window.now >= window.start && window.now < window.end; });
    if (!current) return { label: t('closed'), tone: 'closed' };
    var remaining = current.end - current.now;
    var hasLaterSlot = windows.some(function (window) { return window.start >= current.end; });
    if (!hasLaterSlot && remaining <= 60) {
      if (remaining >= 60) return { label: t('closes_in_hours', { count: '1' }), tone: 'soon' };
      return { label: t('closes_in_minutes', { count: String(Math.max(1, remaining)) }), tone: 'soon' };
    }
    return { label: t('open_now'), tone: 'open' };
  }

  function withCoords(branches) {
    return (branches || []).map(function (branch) {
      var coords = extractLatLng(branch.mapUrl);
      return coords ? Object.assign({}, branch, { coords: coords }) : null;
    }).filter(Boolean);
  }

  function rankBranches(origin, branches) {
    var ranked = withCoords(branches).map(function (branch) {
      return Object.assign({}, branch, { distanceKm: distanceKm(origin, branch.coords) });
    }).sort(function (a, b) { return a.distanceKm - b.distanceKm; });
    var nearby = ranked.filter(function (branch) { return branch.distanceKm <= NEARBY_RADIUS_KM; });
    return nearby.length ? nearby : ranked.slice(0, NEAREST_FALLBACK_COUNT);
  }

  function closestBranches(ranked) {
    return (ranked || []).slice(0, MAP_FOCUS_COUNT);
  }

  function sortAllBranches(origin, branches) {
    return (branches || []).map(function (branch) {
      var coords = branch.coords || extractLatLng(branch.mapUrl);
      if (!origin || !coords) return Object.assign({}, branch, coords ? { coords: coords } : { distanceKm: Infinity });
      return Object.assign({}, branch, { coords: coords, distanceKm: distanceKm(origin, coords) });
    }).sort(function (a, b) {
      var left = typeof a.distanceKm === 'number' ? a.distanceKm : Infinity;
      var right = typeof b.distanceKm === 'number' ? b.distanceKm : Infinity;
      return left - right;
    });
  }

  function pickOthers(origin, branches, currentHandle) {
    return withCoords(branches).filter(function (branch) { return branch.handle !== currentHandle; })
      .map(function (branch) { return Object.assign({}, branch, { distanceKm: distanceKm(origin, branch.coords) }); })
      .sort(function (a, b) { return a.distanceKm - b.distanceKm; })
      .slice(0, OTHER_COUNT);
  }

  function directionsUrl(branch) {
    if (branch.mapUrl) return branch.mapUrl;
    if (!branch.coords) return '';
    return 'https://www.google.com/maps/dir/?api=1&destination=' + branch.coords.latitude + ',' + branch.coords.longitude;
  }

  function icon(name) {
    var solid = {
      plane: '<path d="M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z"/>',
      phone: '<path fill-rule="evenodd" d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z" clip-rule="evenodd"/>'
    };
    if (solid[name]) {
      return '<svg class="dkhoun-branches__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' + solid[name] + '</svg>';
    }
    var paths = {
      pin: '<path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/>',
      calendar: '<rect x="4" y="5" width="16" height="15" rx="2"/><path d="M8 3v4M16 3v4M4 10h16"/>',
      building: '<path stroke-linecap="round" stroke-linejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z"/>',
      share: '<path d="M12 3v12"/><path d="M7 8l5-5 5 5"/><path d="M5 14v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5"/>',
      map: '<path stroke-linecap="round" stroke-linejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z"/>',
      list: '<path d="M8 6h13M8 12h13M8 18h13"/><path d="M3 6h.01M3 12h.01M3 18h.01"/>',
      search: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
      locate: '<circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/>',
      plus: '<path d="M12 5v14M5 12h14"/>',
      minus: '<path d="M5 12h14"/>'
    };
    return '<svg class="dkhoun-branches__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (paths[name] || '') + '</svg>';
  }

  function isInAppBrowser() {
    return /FBAN|FBAV|FB_IAB|Instagram|Line\/|TikTok|Snapchat|Twitter|WhatsApp/i.test(navigator.userAgent || '');
  }

  function needsLocationGesture() {
    var ua = navigator.userAgent || '';
    var iOS = /iP(hone|ad|od)/.test(ua);
    var safari = /Safari/i.test(ua) && !/Chrome|Chromium|CriOS|Edg|Android/i.test(ua);
    return iOS || safari || isInAppBrowser();
  }

  function requestLocation() {
    return new Promise(function (resolve) {
      if (!window.isSecureContext || !navigator.geolocation) {
        resolve({ ok: false, blocked: true });
        return;
      }
      var settled = false;
      function done(result) {
        if (settled) return;
        settled = true;
        resolve(result);
      }
      var timer = window.setTimeout(function () {
        done({ ok: false, blocked: false });
      }, 12000);
      navigator.geolocation.getCurrentPosition(function (position) {
        window.clearTimeout(timer);
        done({
          ok: true,
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        });
      }, function (error) {
        window.clearTimeout(timer);
        done({ ok: false, blocked: !error || error.code === 1 });
      }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 });
    });
  }

  function bindDialog(root, mode) {
    var dialog = root.querySelector('[data-location-dialog]');
    if (!dialog) return { open: function () {}, close: function () {} };
    var title = dialog.querySelector('[data-dialog-title]');
    var message = dialog.querySelector('[data-dialog-message]');
    var allow = dialog.querySelector('[data-dialog-allow]');
    var cancel = dialog.querySelector('[data-dialog-cancel]');
    var onAllow = function () {};

    function open(blocked) {
      if (mode === 'distance') {
        title.textContent = t('location_distance_title');
        message.textContent = blocked ? (isInAppBrowser() ? t('location_in_app_message') : t('location_blocked_message')) : t('location_distance_message');
      } else {
        title.textContent = t('location_required_title');
        message.textContent = blocked ? (isInAppBrowser() ? t('location_in_app_message') : t('location_blocked_message')) : t('location_required_message');
      }
      if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    cancel.addEventListener('click', close);
    allow.addEventListener('click', function () {
      onAllow();
      close();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    return {
      open: open,
      close: close,
      setAllow: function (handler) { onAllow = handler; }
    };
  }

  function renderHours(container, branch) {
    if (!container) return;
    var groups = groupConsecutiveDays(groupHoursByDay(branch.hours));
    if (!groups.length) {
      if (branch.fallbackHours) {
        container.innerHTML = '<div class="dkhoun-branch-detail__line">' + icon('calendar') + '<span>' + escapeHtml(branch.fallbackHours) + '</span></div>';
      }
      return;
    }
    container.innerHTML = groups.map(function (group) {
      var slots = group.isClosed
        ? '<p class="dkhoun-branch-detail__hour-slot dkhoun-branch-row__status is-closed">' + escapeHtml(t('closed')) + '</p>'
        : group.slots.map(function (slot) {
          return '<p class="dkhoun-branch-detail__hour-slot">' + escapeHtml(formatHourRange(slot.openingTime, slot.closingTime)) + '</p>';
        }).join('');
      return '<div class="dkhoun-branch-detail__hour-group"><div class="dkhoun-branch-detail__hour-days">' + icon('calendar') + '<span>' + escapeHtml(formatDayRange(group.weekdays)) + '</span></div>' + slots + '</div>';
    }).join('');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function statusHtml(branch) {
    var status = resolveBranchStatus(branch.hours);
    return '<span class="dkhoun-branch-row__status is-' + status.tone + '">' + escapeHtml(status.label) + '</span>';
  }

  function rowHtml(branch, showDirections) {
    var distance = typeof branch.distanceKm === 'number'
      ? '<p class="dkhoun-branch-row__meta">' + icon('map') + '<span>' + escapeHtml(t('distance_away', { distance: formatDistanceKm(branch.distanceKm) })) + '</span></p>'
      : '';
    var routeUrl = directionsUrl(branch);
    var routeButton = routeUrl
      ? '<a class="dkhoun-branch-row__route" data-branch-directions href="' + escapeHtml(routeUrl) + '" target="_blank" rel="noopener noreferrer">' + icon('plane') + '<span>' + escapeHtml(t('directions')) + '</span></a>'
      : '';
    var infoButton = '<span class="dkhoun-branch-row__directions"><span>' + escapeHtml(t('branch_info')) + '</span></span>';
    var address = branch.address
      ? '<p class="dkhoun-branch-row__address">' + icon('building') + '<span>' + escapeHtml(branch.address) + '</span></p>'
      : '';
    return '<li><div class="dkhoun-branch-row" data-branch-open="' + escapeHtml(branch.handle) + '" role="button" tabindex="0">' + statusHtml(branch) + '<div class="dkhoun-branch-row__body"><h3 class="dkhoun-branch-row__title"><span>' + escapeHtml(branch.name) + '</span></h3>' + distance + address + '<div class="dkhoun-branch-row__actions">' + infoButton + routeButton + '</div></div></div></li>';
  }

  function initIndex(root, branches) {
    var input = root.querySelector('[data-branch-search]');
    var empty = root.querySelector('[data-branch-empty]');
    var dialog = bindDialog(root, 'nearest');
    var locate = root.querySelector('[data-detect-location]');
    var nearestUrl = root.getAttribute('data-nearest-url') || '/pages/branches-nearest';

    function go(coords) {
      var url = nearestUrl;
      if (coords) url += (url.indexOf('?') === -1 ? '?' : '&') + 'lat=' + coords.latitude + '&lng=' + coords.longitude;
      window.location.href = url;
    }

    async function ask() {
      if (locate) locate.disabled = true;
      var result = await requestLocation();
      if (locate) locate.disabled = false;
      if (result.ok) {
        dialog.close();
        go({ latitude: result.latitude, longitude: result.longitude });
        return;
      }
      dialog.open(result.blocked);
    }

    dialog.setAllow(ask);
    if (locate) locate.addEventListener('click', ask);

    if (!input) return;
    input.addEventListener('input', function () {
      var query = normalizeSearchText(input.value);
      var visible = 0;
      root.querySelectorAll('[data-branch-section]').forEach(function (section) {
        var count = 0;
        section.querySelectorAll('[data-branch-card]').forEach(function (card) {
          var match = !query || normalizeSearchText(card.getAttribute('data-search')).indexOf(query) !== -1;
          card.hidden = !match;
          if (match) count += 1;
        });
        section.hidden = query && count === 0;
        visible += count;
      });
      if (empty) {
        empty.classList.toggle('is-visible', Boolean(query) && visible === 0);
        var term = empty.querySelector('[data-empty-term]');
        if (term) term.textContent = input.value.trim();
      }
    });
    branches;
  }

  function initNearest(root, branches) {
    var dialog = bindDialog(root, 'nearest');
    var list = root.querySelector('[data-nearest-list]');
    var countNode = root.querySelector('[data-nearest-count]');
    var params = new URLSearchParams(window.location.search);
    var latParam = params.get('lat');
    var lngParam = params.get('lng');
    var lat = Number(latParam);
    var lng = Number(lngParam);
    var origin = latParam && lngParam && Number.isFinite(lat) && Number.isFinite(lng) ? { latitude: lat, longitude: lng } : null;
    var mapApi = null;
    var ranked = [];
    var visibleCount = LIST_PREVIEW_COUNT;
    var searchInput = root.querySelector('[data-branch-search]');
    var locate = root.querySelector('[data-detect-location]');
    var loadMore = root.querySelector('[data-load-more]');

    function nearestPage(source) {
      return source.slice(0, visibleCount);
    }

    function renderList() {
      var query = normalizeSearchText(searchInput ? searchInput.value : '');
      var source = query ? branches : ranked;
      var visible = source.filter(function (branch) {
        if (!query) return true;
        var haystack = normalizeSearchText([branch.name, branch.address, branch.city, branch.region, branch.handle].join(' '));
        return haystack.indexOf(query) !== -1;
      }).map(function (branch) {
        if (!origin || typeof branch.distanceKm === 'number') return branch;
        var coords = branch.coords || extractLatLng(branch.mapUrl);
        if (!coords) return branch;
        return Object.assign({}, branch, { distanceKm: distanceKm(origin, coords) });
      });
      if (query && origin) {
        visible.sort(function (a, b) {
          var left = typeof a.distanceKm === 'number' ? a.distanceKm : Infinity;
          var right = typeof b.distanceKm === 'number' ? b.distanceKm : Infinity;
          return left - right;
        });
      }
      var shown = query ? visible : nearestPage(visible);
      if (countNode) countNode.textContent = t('nearest_branche_subtitle', { count: String(shown.length) });
      if (list) list.innerHTML = shown.map(function (branch) { return rowHtml(branch, true); }).join('');
      if (loadMore) loadMore.hidden = Boolean(query) || shown.length >= visible.length;
      return shown;
    }

    function paint(point) {
      origin = point;
      visibleCount = LIST_PREVIEW_COUNT;
      ranked = sortAllBranches(point, branches);
      renderList();
      if (mapApi) {
        mapApi.update({
          origin: point,
          focus: closestBranches(ranked),
          branches: withCoords(branches)
        });
      }
    }

    function saveLocation(latitude, longitude) {
      var url = new URL(window.location.href);
      url.searchParams.set('lat', String(latitude));
      url.searchParams.set('lng', String(longitude));
      window.location.assign(url.toString());
    }

    function requestFromGesture() {
      if (!window.isSecureContext || !navigator.geolocation) {
        dialog.open(true);
        return;
      }
      var finished = false;
      var watchId = null;
      function finish(position) {
        if (finished) return;
        finished = true;
        if (watchId !== null) navigator.geolocation.clearWatch(watchId);
        saveLocation(position.coords.latitude, position.coords.longitude);
      }
      function fail(error) {
        if (finished) return;
        finished = true;
        if (watchId !== null) navigator.geolocation.clearWatch(watchId);
        dialog.open(!error || error.code === 1);
      }
      watchId = navigator.geolocation.watchPosition(finish, fail, {
        enableHighAccuracy: false,
        timeout: 20000,
        maximumAge: 60000
      });
    }

    async function ask() {
      var result = await requestLocation();
      if (result.ok) {
        dialog.close();
        saveLocation(result.latitude, result.longitude);
        return { latitude: result.latitude, longitude: result.longitude };
      }
      dialog.open(result.blocked);
      return null;
    }

    dialog.setAllow(requestFromGesture);
    if (locate) locate.addEventListener('click', requestFromGesture);
    if (searchInput) searchInput.addEventListener('input', renderList);
    if (loadMore) {
      loadMore.addEventListener('click', function () {
        visibleCount += LOAD_MORE_COUNT;
        var shown = renderList();
        if (mapApi) {
          mapApi.update({
            origin: origin,
            focus: withCoords(shown),
            branches: withCoords(branches)
          });
        }
      });
    }

    if (window.DkhounBranchesMap) {
      var initialFocus = origin ? closestBranches(sortAllBranches(origin, branches)) : [];
      mapApi = window.DkhounBranchesMap.init(root, {
        origin: origin,
        branches: withCoords(branches),
        focus: initialFocus,
        onDetect: ask
      });
    }

    if (list) {
      list.addEventListener('click', function (event) {
        if (event.target.closest('[data-branch-directions]')) return;
        var card = event.target.closest('[data-branch-open]');
        if (!card || !list.contains(card)) return;
        openDrawer(card.getAttribute('data-branch-open'));
      });
      list.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (event.target.closest('[data-branch-directions]')) return;
        var card = event.target.closest('[data-branch-open]');
        if (!card || event.target !== card) return;
        event.preventDefault();
        openDrawer(card.getAttribute('data-branch-open'));
      });
    }

    function branchByHandle(handle) {
      return branches.find(function (branch) { return branch.handle === handle; }) || null;
    }

    function setBranchParam(handle) {
      var url = new URL(window.location.href);
      if (handle) url.searchParams.set('branch-id', handle);
      else url.searchParams.delete('branch-id');
      window.history.replaceState({}, '', url);
    }

    var drawerHideTimer = 0;

    function otherBranchHtml(item) {
      var status = resolveBranchStatus(item.hours);
      var media = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="">'
        : '';
      var distance = typeof item.distanceKm === 'number'
        ? '<span class="dkhoun-branch-drawer__other-meta">' + icon('map') + '<span>' + escapeHtml(t('distance_away', { distance: formatDistanceKm(item.distanceKm) })) + '</span></span>'
        : '';
      var address = item.address
        ? '<span class="dkhoun-branch-drawer__other-meta">' + icon('building') + '<span>' + escapeHtml(item.address) + '</span></span>'
        : '';
      return '<li><button type="button" class="dkhoun-branch-drawer__other" data-branch-open="' + escapeHtml(item.handle) + '"><span class="dkhoun-branch-drawer__other-media">' + media + '</span><span class="dkhoun-branch-drawer__other-body"><span class="dkhoun-branch-drawer__other-title"><strong>' + escapeHtml(item.name) + '</strong><span class="dkhoun-branch-row__status is-' + status.tone + '">' + escapeHtml(status.label) + '</span></span>' + distance + address + '</span></button></li>';
    }

    function fillDrawer(branch) {
      var panel = root.querySelector('[data-drawer-panel]');
      if (!panel || !branch) return;
      var status = resolveBranchStatus(branch.hours);
      var coords = extractLatLng(branch.mapUrl);
      var distance = origin && coords
        ? t('distance_away', { distance: formatDistanceKm(distanceKm(origin, coords)) })
        : t('enable_location_for_distance');
      var place = [branch.city, branch.region].filter(Boolean).join(' – ');
      var tel = phoneHref(branch.phone);
      var hero = branch.image
        ? '<img src="' + escapeHtml(branch.image) + '" alt="' + escapeHtml(branch.name) + '">'
        : '';
      var othersOrigin = origin || coords;
      var others = othersOrigin ? pickOthers(othersOrigin, branches, branch.handle) : [];
      var othersHtml = others.length
        ? '<h2 class="dkhoun-branch-drawer__others-title">' + escapeHtml(t('other_branches')) + '</h2><ul class="dkhoun-branch-drawer__others">' + others.map(otherBranchHtml).join('') + '</ul>'
        : '';
      var closeIcon = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path stroke-linecap="round" d="M6 6l12 12M18 6 6 18"/></svg>';
      panel.innerHTML = '<div class="dkhoun-branch-drawer__hero">' + hero + '<span class="dkhoun-branch-detail__badge is-' + status.tone + '">' + escapeHtml(status.label) + '</span><button type="button" class="dkhoun-branch-drawer__close" data-drawer-close aria-label="' + escapeHtml(t('cancel')) + '">' + closeIcon + '</button></div><div class="dkhoun-branch-drawer__content"><h2>' + escapeHtml(branch.name) + '</h2><p class="dkhoun-branch-detail__line">' + icon('map') + '<span>' + escapeHtml(distance) + '</span></p>' + (place ? '<p class="dkhoun-branch-detail__line">' + icon('pin') + '<span>' + escapeHtml(place) + '</span></p>' : '') + (branch.address ? '<p class="dkhoun-branch-detail__line">' + icon('building') + '<span>' + escapeHtml(branch.address) + '</span></p>' : '') + '<div class="dkhoun-branch-detail__hours" data-drawer-hours></div><div class="dkhoun-branch-detail__actions">' + (branch.mapUrl ? '<a class="dkhoun-branch-detail__primary" href="' + escapeHtml(branch.mapUrl) + '" target="_blank" rel="noopener noreferrer">' + icon('plane') + '<span>' + escapeHtml(t('directions_google')) + '</span></a>' : '') + '<div class="dkhoun-branch-detail__row"><button type="button" class="dkhoun-branch-detail__secondary" data-drawer-share>' + icon('share') + '<span>' + escapeHtml(t('share_branch')) + '</span></button>' + (tel ? '<a class="dkhoun-branch-detail__secondary" href="tel:' + escapeHtml(tel) + '">' + icon('phone') + '<span>' + escapeHtml(t('call_branch')) + '</span></a>' : '') + '</div></div>' + othersHtml + '</div>';
      panel.setAttribute('aria-label', branch.name || '');
      renderHours(panel.querySelector('[data-drawer-hours]'), branch);
      var share = panel.querySelector('[data-drawer-share]');
      if (share) {
        share.addEventListener('click', function () {
          var shareUrl = window.location.href;
          if (navigator.share) navigator.share({ url: shareUrl }).catch(function () {});
          else if (navigator.clipboard) navigator.clipboard.writeText(shareUrl);
        });
      }
    }

    function openDrawer(handle, updateUrl) {
      var branch = branchByHandle(handle);
      var drawer = root.querySelector('[data-branch-drawer]');
      if (!branch || !drawer) return;
      window.clearTimeout(drawerHideTimer);
      fillDrawer(branch);
      drawer.hidden = false;
      window.requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      if (updateUrl !== false) setBranchParam(handle);
    }

    function closeDrawer(updateUrl) {
      var drawer = root.querySelector('[data-branch-drawer]');
      if (!drawer || (drawer.hidden && !drawer.classList.contains('is-open'))) return;
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      drawerHideTimer = window.setTimeout(function () { drawer.hidden = true; }, 280);
      if (updateUrl !== false) setBranchParam('');
    }

    window.DkhounBranches = { open: function (handle) { openDrawer(handle); } };

    var drawer = root.querySelector('[data-branch-drawer]');
    if (drawer) {
      drawer.addEventListener('click', function (event) {
        if (event.target.closest('[data-drawer-overlay]') || event.target.closest('[data-drawer-close]')) {
          closeDrawer();
          return;
        }
        var next = event.target.closest('[data-branch-open]');
        if (next && drawer.contains(next)) openDrawer(next.getAttribute('data-branch-open'));
      });
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });

    var fab = root.querySelector('.dkhoun-branches-fab');
    var fabShade = root.querySelector('.dkhoun-branches-fab-shade');
    function parkFab() {
      if (!fab) return;
      var bottomGap = parseFloat(getComputedStyle(fab).bottom) || 0;
      var fabHeight = fab.offsetHeight || 0;
      var limit = window.innerHeight - bottomGap - fabHeight;
      var parked = root.getBoundingClientRect().bottom <= limit;
      fab.classList.toggle('is-parked', parked);
      if (fabShade) fabShade.classList.toggle('is-parked', parked);
    }
    parkFab();
    window.addEventListener('scroll', parkFab, { passive: true });
    window.addEventListener('resize', parkFab);

    if (origin) paint(origin);
    else if (needsLocationGesture()) {
      visibleCount = LIST_PREVIEW_COUNT;
      ranked = sortAllBranches(null, branches);
      renderList();
      dialog.open(false);
    } else ask();

    var initialBranch = params.get('branch-id');
    if (initialBranch) openDrawer(initialBranch, false);
  }

  function phoneHref(phone) {
    var value = String(phone || '').replace(/\s+/g, '');
    if (!value) return '';
    return value.charAt(0) === '+' ? value : '+' + value;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var catalog = readJson('DkhounBranchesCatalog') || [];
    window.DkhounBranchesI18n = readJson('DkhounBranchesI18n') || {};
    document.querySelectorAll('[data-dkhoun-branches]').forEach(function (root) {
      var mode = root.getAttribute('data-dkhoun-branches');
      if (mode === 'index') initIndex(root, catalog);
      if (mode === 'nearest') initNearest(root, catalog);
    });
  });
})();
